<template>
  <div>
    <div>
      <div v-show="!isProspect">
        <div>Installation fees are currently waived.</div>
        <br/>
        <div>
          <h5>Desired activation date</h5>
        </div>
        <div>
          <label>When would you like your installation to occur? Note that Bonfire will call you beforehand to confirm or update your activation time.</label>
          <b-form-datepicker v-model="form_data.desired_activation_date" :min="min_date"></b-form-datepicker>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { BFormDatepicker } from 'bootstrap-vue';
  import XmInput from '../../XmInput.vue';
  import FormValidator from "../../FormValidator.vue";
  import reg from "../../../lib/regex";
  import ConnectivityService from '../../../lib/ssu/input_models/connectivity-service';
  import SpeedSelect from '../../Signup/SpeedSelect.vue';

export default {
  data () {
    return {
      form_data: {desired_activation_date: ''},
      regex: reg,
      overlay_text: '',
      min_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000)  // tomorrows date
    }
  },

  mounted () {
    this.$emit('form-state', this.serviceValid);
  },

  props: {
    value: {
      required: false,
      default: () => {}
    },
    // service should be an instance of ConnectivityService
    service: {
      required: true,
      type: ConnectivityService
    }
  },

  computed: {
    activationDateChosen () {
      return this.form_data.desired_activation_date !== '';
    },
    isProspect() {
      return this.service.address_details.early_signup;
    },
    serviceValid() {
      if (!this.isProspect){
        return this.activationDateChosen;
      }
      return true;
    },
    serviceSubmissionData () {
      return this.form_data;
    }
  },

  methods: {
    resetForm () {
      this.form_data = {is_tribal: null,
                        desired_activation_date: ''};
    }
  },

  watch : {
    serviceValid(new_val, old_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },
    serviceSubmissionData: {
      handler(new_val, old_val) {
        this.$emit('input', new_val);
      },
      deep: true
    },
  },

  components : {
    XmInput,
    FormValidator,
    SpeedSelect,
    BFormDatepicker
  }

}
</script>



// WEBPACK FOOTER //
// BonfireResidential.vue?7702c551